<div class="dashboard-header">
	<div class="dashboard-title">MSVS Dashboard</div>
	<div class="dashboard-updated">Last Updated</div>
</div>
<div class="row g-3 mb-3">
	<div class="col">
		<div class="card h-100">
			<div class="card-body">
				<div class="row g-3">
					<div class="col">
						<label for="inputStartDate" class="form-label">Start Date</label>
						<div class="input-group">
							<input
								id="inputStartDate"
								class="form-control"
								placeholder="yyyy-mm-dd"
								name="dp"
								[(ngModel)]="startModel"
								ngbDatepicker
								#start="ngbDatepicker"
								readonly
								(dateSelect)="update()"/>
							<button class="btn btn-outline-secondary" (click)="start.toggle()" type="button">
								<fa-icon [icon]="faCalendar"></fa-icon>
							</button>
						</div>
						<div class="text-body-secondary" style="font-size: 0.5em;" *ngIf="dateRange">Previous Period: Start</div>
						<div class="text-body-secondary" style="font-size: 0.5em;" *ngIf="dateRange">{{dateRange.previousStartDate}}</div>
					</div>
					<div class="col">
						<label for="inputEndDate" class="form-label">End Date</label>
						<div class="input-group">
							<input
								id="inputEndDate"
								class="form-control"
								placeholder="yyyy-mm-dd"
								name="dp"
								[(ngModel)]="endModel"
								ngbDatepicker
								readonly
								#end="ngbDatepicker"
								(dateSelect)="update()"/>
							<button class="btn btn-outline-secondary" (click)="end.toggle()" type="button">
								<fa-icon [icon]="faCalendar"></fa-icon>
							</button>
						</div>
						<div class="text-body-secondary" style="font-size: 0.5em;" *ngIf="dateRange">Previous Period: End</div>
						<div class="text-body-secondary" style="font-size: 0.5em;" *ngIf="dateRange">{{dateRange.previousEndDate}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<div class="col">
		<div class="card h-100">
			<div class="card-body">
				<label for="inputStartDate" class="form-label">Partner</label>
				<select id="partnerSelect" class="form-select" (change)="update()" name="partnerSelect" [(ngModel)]="selectedPartner">
					<ng-container *ngIf="partners.length == 1">
						<option selected [ngValue]="partners[0]">{{partners[0].name}}</option>
					</ng-container>

					<ng-container *ngIf="partners.length != 1">
						<option [ngValue]="undefined">All</option>
						<option *ngFor="let partner of partners" [ngValue]="partner">{{partner.name}}</option>
					</ng-container>
				</select>
			</div>
		</div>
	</div>
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="activeAgentCount" defaultTitle="Total Agents Active (count)"></app-dashboard-component>
	</div>
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="pendingApprovals" defaultTitle="Agents Pending Approval (count)"></app-dashboard-component>
	</div>
</div>
<div class="row g-3 mb-3">
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="registrationCount" defaultTitle="Active Subscriber (count)"></app-dashboard-component>
	</div>
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="registrationActiveCount" defaultTitle="New Subscriber (count)"></app-dashboard-component>
	</div>
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="thirdPartyApiCallCount" defaultTitle="Third Party Lookups"></app-dashboard-component>
	</div>
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="activeAgentSessions" defaultTitle="Agent Sessions (count)"></app-dashboard-component>
	</div>
</div>

<div class="row g-3 mb-3">
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="registrationPerPartner" defaultTitle="Registrations Per Partner"></app-dashboard-component>
	</div>
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="registrationSimStatus" defaultTitle="Registration Sim Status"></app-dashboard-component>
	</div>
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="agentStatusDistribution" defaultTitle="Agent Status Distribution"></app-dashboard-component>
	</div>
</div>

<div class="row g-3 mb-3">
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="dataFileRecordsProcessing" defaultTitle="Registration Onboarding"></app-dashboard-component>
	</div>
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="dataFileRecordsPendingImport" defaultTitle="Registrations Pending Import"></app-dashboard-component>
	</div>
	<div class="col">
		<app-dashboard-component [isLoading]="loading" [data]="thirdPartyThroughput" defaultTitle="Third Party Throughput"></app-dashboard-component>
	</div>
</div>
